
import React from 'react';
import { Button } from '@/components/ui/button';
import { Camera } from 'lucide-react';

interface CameraButtonProps {
  onClick: () => void;
  isMobile: boolean;
}

const CameraButton = ({ onClick, isMobile }: CameraButtonProps) => {
  const handleButtonClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    console.log('Camera button clicked, opening scanner');
    onClick();
  };

  return (
    <Button 
      className="w-full gap-2 font-medium shadow-md border-2 border-amber-100 dark:border-amber-500/40 bg-amber-400 hover:bg-amber-500 text-amber-900 transition-all duration-300 relative z-30" 
      onClick={handleButtonClick}
      size={isMobile ? "lg" : "default"}
      data-qr-scanner-button="true"
      type="button"
    >
      <Camera className={isMobile ? "h-6 w-6" : "h-5 w-5"} />
      {isMobile ? "Mở camera QR" : "Quét bằng camera"}
    </Button>
  );
};

export default CameraButton;
